import { Add } from "@mui/icons-material";
import { Button, MenuItem, MenuList, Stack, Typography } from "@mui/material";
import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { useGetConversationThreadsQuery } from "src/api/services/conversationThreadsApi";
import { useQueryParams } from "src/hooks/useQueryParams";

const ConversationThreadsList = () => {
  const { data = [] } = useGetConversationThreadsQuery({ agent: "vida" });
  const { setParams, deleteParams } = useQueryParams();
  const [searchParams] = useSearchParams();

  const selectedThread = useMemo(
    () => searchParams.get("conversation"),
    [searchParams],
  );

  const handleSelect = useCallback(
    (conversationId: string) => {
      setParams({ conversation: conversationId });
    },
    [setParams],
  );

  const handleNewConversation = useCallback(() => {
    deleteParams(["conversation"]);
  }, [deleteParams]);

  if (data.length === 0) {
    return (
      <Typography p={2} color="text.secondary">
        No conversations yet
      </Typography>
    );
  }

  return data.length === 0 ? null : (
    <Stack sx={{ overflow: "auto" }}>
      <Button
        startIcon={<Add />}
        variant="text"
        onClick={handleNewConversation}
      >
        New conversation
      </Button>
      <MenuList>
        {data.map((thread) => (
          <MenuItem
            key={thread.id}
            onClick={() => handleSelect(thread.conversation_id)}
            selected={selectedThread === thread.conversation_id}
          >
            <Typography p={1} noWrap title={thread.title}>
              {thread.title}
            </Typography>
          </MenuItem>
        ))}
      </MenuList>
    </Stack>
  );
};

export default ConversationThreadsList;
